<div class="container-fluid g-0 m-0">
  <div class="row g-0 m-0 d-flex pt-5 align-items-center">
    <div class="col-md-1 d-flex pe-4 justify-content-end">
      <div class="button-back pb-1" [routerLink]="['/on-demand/energy']">
        <svg-icon alt="Back" src="assets/core/back-button.svg"></svg-icon>
      </div>
    </div>
    <div class="col-md-6">
      <h2 class="col pb-2 m-0 title">
        {{ "ENERGY_REGISTER_DATA" | translate }}
        {{ "DETAILS" | translate }}
      </h2>
      <h6 class="col subtitle">
        {{ "ONDEMANDENERGY_SUBTITLE" | translate }}
      </h6>
    </div>
    @if (
      authService.isAuthorized([
        PermissionEnum.Ondemand_energyregister_download,
      ])
    ) {
      <div
        class="col-md-5 d-flex justify-content-end align-items-center gap-2 pe-5"
      >
        <div class="download-button ps-3 pe-3 pb-2 pt-1" (click)="download()">
          <svg-icon
            alt="Download"
            class="hover-effect"
            src="assets/core/table/download.svg"
          ></svg-icon>
        </div>
      </div>
    }
  </div>
  <div #tableContainer class="table-container mt-5">
    <table>
      <thead>
        <tr>
          <td class="custom-width">
            {{ "TIME" | translate | uppercase }} {{ "INTERVAL" | translate }}
          </td>
          <td>{{ "ENERGYREGISTERS_ABSOLUTEENERGY" | translate | uppercase }}</td>
          <td colspan="2">{{ "ENERGYREGISTERS_ACTIVEENERGY" | translate | uppercase }}</td>
          <td colspan="2">{{ "ENERGYREGISTERS_REACTIVEENERGY" | translate | uppercase }}</td>
          <td colspan="2">{{ "ENERGYREGISTERS_APPARENTENERGY" | translate | uppercase }}</td>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of data">
          <td class="table-name-number">
            <span>{{ item.meterTime | date: "dd MMM yyyy, h:mm a" }}</span>
          </td>

          <!-- Absolute Energy -->
          <td>
              <span [attr.title]="item.absoluteActiveEnergy + ' WH'">
              {{ item.absoluteActiveEnergy == null ? "N/A" :
                item.absoluteActiveEnergy | unitConverter: "WH"
              }}</span>
          </td>

          <!-- Active Energy -->
          <td class="import-cell">
            <div class="cell">
              <img alt="Import" src="assets/load-profile/im.svg" />
              <span [attr.title]="item.activeEnergyImport + ' WH'">{{
                item.activeEnergyImport == null ? "N/A" :
                (item.activeEnergyImport | unitConverter: "WH")
              }}</span>
            </div>
          </td>
          <td class="export-cell">
            <div class="cell">
              <img alt="Export" src="assets/load-profile/ex.svg" />
              <span [attr.title]="item.activeEnergyExport + ' WH'">{{
                item.activeEnergyExport == null ? "N/A" :
                (item.activeEnergyExport | unitConverter: "WH")
              }}</span>
            </div>
          </td>

          <!-- Reactive Energy -->
          <td class="import-cell">
            <div class="cell">
              <img alt="Import" src="assets/load-profile/im.svg" />
              <span [attr.title]="item.reactiveEnergyImport + ' VARH'">{{
                item.reactiveEnergyImport == null ? "N/A" :
                (item.reactiveEnergyImport | unitConverter: "VARH")
              }}</span>
            </div>
          </td>
          <td class="export-cell">
            <div class="cell">
              <img alt="Export" src="assets/load-profile/ex.svg" />
              <span [attr.title]="item.reactiveEnergyExport + ' VARH'">{{
                item.reactiveEnergyExport == null ? "N/A" :
                (item.reactiveEnergyExport | unitConverter: "VARH")
              }}</span>
            </div>
          </td>

          <!-- Apparent Energy -->
          <td class="import-cell">
            <div class="cell">
              <img alt="Import" src="assets/load-profile/im.svg" />
              <span [attr.title]="item.apparentEnergyImport + ' VAH'">{{
                item.apparentEnergyImport == null ? "N/A" :
                (item.apparentEnergyImport | unitConverter: "VAH")
              }}</span>
            </div>
          </td>
          <td class="export-cell">
            <div class="cell">
              <img alt="Export" src="assets/load-profile/ex.svg" />
              <span [attr.title]="item.apparentEnergyExport + ' VAH'">{{
                item.apparentEnergyExport == null ? "N/A" :
                (item.apparentEnergyExport | unitConverter: "VAH")
              }}</span>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="container-down">
    <app-pagination
      [lastPageSize]="lastPageSize"
      [numberOfDevices]="numberOfCommands"
      [pageSize]="pageSize"
      [currentPage]="currentPage"
      (pageChange)="pageChange($event)"
    ></app-pagination>
  </div>
</div>
